// Zanzibar destination — packages DERIVED from the single source
// (data/zanzibarSafariData.js → tours, relocated out of the ZanzibarSafari.js component).
import { tours } from '../zanzibarSafariData';
import { canonicalPackage, toNumber } from './adapt';

const packages = tours.map((p) =>
  canonicalPackage({
    id: p.id,
    name: p.title,
    countryName: 'Zanzibar',
    duration: p.duration, // "8-10 hours" — kept as-is; durationDays resolves to null
    priceFrom: toNumber(p.price),
    description: p.description || '',
    highlights: p.highlights || [],
    regions: [],
    coverImage: p.image,
    rating: p.rating ?? null,
    category: p.category,
  })
);

export const zanzibarDestination = {
  key: 'zanzibar',
  name: 'Zanzibar',
  emoji: '🏝️',
  tagline: 'Pristine beaches, spice tours, and rich Swahili culture',
  signature: 'Spice Island Experience',
  heroImage:
    'https://images.unsplash.com/photo-1621583628955-42fbc37bf424?w=1920&h=1080&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8emFuemliYXJ8ZW58MHx8MHx8fDA%3D',
  highlights: ['Stone Town', 'Spice Tours', 'Safari Blue', 'Prison Island'],
  bestTime: 'June-October (Dry season), December-February (Cool season)',
  wildlife: ['Dolphins', 'Sea turtles', 'Red Colobus monkeys', 'Tropical fish'],
  climate: 'Tropical with monsoon seasons',
  currency: 'Tanzanian Shilling (TZS)',
  language: 'Swahili, English, Arabic',
  mapCenter: [-6.1659, 39.2026],
  mapMarkers: [
    { position: [-6.1659, 39.2026], name: 'Stone Town' },
    { position: [-5.7213, 39.2927], name: 'Nungwi' },
    { position: [-6.4789, 39.5104], name: 'Jozani Forest' },
    { position: [-6.0535, 39.327], name: 'Prison Island' },
  ],
  packages,
};
